module.exports = __webpack_public_path__ + "img/cut_sc3.2cd6d6fa.png";